(function(){
     'use strict';

     angular
        .module('app')
        .factory('CalendarioService', CalendarioService);

    CalendarioService.$inject = ['$http'];

    function CalendarioService($http){


        var service= {
            saveCalendarioAus: saveCalendarioAus
        };

        return service;

        function saveCalendarioAus(datos,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
                 fecha : datos["fecha"],
                 fecha_fin : datos["fecha_fin"],
                 descripcion : datos["descripcion"],
                 tipoausencia_id : datos["tipoausencia_id"]
            });
            $http.post('/backend/calendarioaus/guardar', data, config)
            .success(getContentSuccess)
            .error(getContentFailed);
            function getContentSuccess(data){ 
                callback(data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
    }
})();